var _path, _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgChooseusCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3691C0 7.08487 6.71573 0.369141 15 0.369141H40V25.3691C40 33.6534 33.2843 40.3691 25 40.3691H0V15.3691Z",
    fill: "url(#paint0_linear_1523_3702)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1523_3702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2327 7.99378C18.6752 7.55187 19.2672 7.29184 19.892 7.265C20.5168 7.23816 21.129 7.44645 21.6077 7.84878L21.7677 7.99503L24.1427 10.3688H27.5002C28.1307 10.3689 28.7379 10.6072 29.2001 11.0361C29.6623 11.4649 29.9454 12.0525 29.9927 12.6813L30.0002 12.8688V16.2263L32.3752 18.6013C32.8175 19.0438 33.0777 19.6361 33.1046 20.2612C33.1314 20.8863 32.9229 21.4987 32.5202 21.9775L32.374 22.1363L29.999 24.5113V27.8688C29.9992 28.4995 29.7609 29.107 29.3321 29.5695C28.9032 30.0319 28.3154 30.3152 27.6865 30.3625L27.5002 30.3688H24.144L21.769 32.7438C21.3264 33.186 20.7341 33.4463 20.109 33.4731C19.484 33.5 18.8715 33.2915 18.3927 32.8888L18.234 32.7438L15.859 30.3688H12.5002C11.8695 30.369 11.262 30.1308 10.7995 29.7019C10.337 29.273 10.0538 28.6852 10.0065 28.0563L10.0002 27.8688V24.5113L7.62521 22.1363C7.18295 21.6937 6.9227 21.1014 6.89586 20.4764C6.86901 19.8513 7.07752 19.2389 7.48021 18.76L7.62521 18.6013L10.0002 16.2263V12.8688C10.0003 12.2383 10.2387 11.6311 10.6675 11.1689C11.0963 10.7067 11.684 10.4236 12.3127 10.3763L12.5002 10.3688H15.8577L18.2327 7.99378ZM23.849 16.5975L18.544 21.9025L16.334 19.6925C16.0994 19.4581 15.7814 19.3265 15.4498 19.3266C15.1182 19.3268 14.8002 19.4586 14.5658 19.6932C14.3314 19.9277 14.1998 20.2458 14.2 20.5773C14.2001 20.9089 14.3319 21.2269 14.5665 21.4613L17.5715 24.4663C17.6991 24.594 17.8508 24.6954 18.0176 24.7645C18.1845 24.8336 18.3633 24.8692 18.544 24.8692C18.7246 24.8692 18.9034 24.8336 19.0703 24.7645C19.2372 24.6954 19.3888 24.594 19.5165 24.4663L25.6165 18.365C25.8442 18.1293 25.9701 17.8135 25.9673 17.4858C25.9645 17.158 25.833 16.8445 25.6012 16.6128C25.3695 16.381 25.056 16.2495 24.7282 16.2467C24.4005 16.2438 24.0847 16.3698 23.849 16.5975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1523_3702",
    x1: 4.5,
    y1: 4.86914,
    x2: 52.5,
    y2: 52.8691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190625,
    stopColor: "#36B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753125,
    stopColor: "#0275BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1523_3702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(5 5.36914)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseusCheck);
export default __webpack_public_path__ + "static/media/chooseus-check.f6d4e447a84ac9d176cb3513bc02bfda.svg";
export { ForwardRef as ReactComponent };